import { TypedHandler } from './../../types/handlers';
import { SimpleTypedHandler } from 'app/types/handlers';
import { LngLatZoom } from 'app/types/lng-lat-zoom';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { environment } from 'app/../environments/environment';
import { Decorable } from 'app/types/decorable';
import * as mapboxgl from 'mapbox-gl';


@Injectable({
	providedIn: 'root'
})
export class GeocodeService {

	constructor(private http: HttpClient) { }
	public lastResults: any;

	Search(term: string, urlParams: Decorable):Observable<any> {
		if (term === '' || term.length < 2) {
			return of([]);
		}

		const URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + term + '.json';
		urlParams.access_token = environment.mapbox.accessToken;

		const obs = this.http.get(URL, { params: urlParams });

		obs.toPromise().then((response) => {
			this.lastResults = response;
		});
		return obs;
	}
  GetGPSLocation(handler:TypedHandler<LngLatZoom|undefined>) {
    if(!navigator) {
      handler(undefined);
      return;
    }
    if(!navigator.geolocation) {
      handler(undefined);
      return;
    }
    navigator.geolocation.getCurrentPosition((info:GeolocationPosition)=>{
      const result:LngLatZoom = {
        lng:info.coords.longitude,
        lat:info.coords.latitude,
        zoom:15
      }
      handler(result);
    }, () => {
      handler(undefined);
    }, { enableHighAccuracy: true, timeout: 250 });
  }
  /* GpsCenter(map: MapComponent) {
		if (navigator.geolocation) {

			navigator.geolocation.getCurrentPosition((info) => {
				const event: NavEvent = NavEvents.New('navigation/gps-center');
				map.SLMap.ui.setCenter(new LngLat(info.coords.longitude, info.coords.latitude), event);
				map.SLMap.ui.setZoom(19, event);
			}, () => { }, { enableHighAccuracy: true, timeout: 250 });
		}
	}
	public static GpsAutoOrient(map: MapComponent) {
		if (NavigationAction.geoWatcher !== -1) {
			navigator.geolocation.clearWatch(NavigationAction.geoWatcher);
			NavigationAction.geoWatcher = -1;
			map.SLMap.src.StopGPS();
			return;
		}
		map.SLMap.src.StartGPS();
		NavigationAction.geoWatcher = navigator.geolocation.watchPosition((info) => {
			this.GPSAutoOrientAction(map, info);
		}, (error) => {
			switch (error.code) {
				case error.PERMISSION_DENIED:
				case error.POSITION_UNAVAILABLE:
				case error.TIMEOUT:
					break;

			}
		});
	}
	public static GPSAutoOrientAction(map: MapComponent, info: any) {
		if (NavigationAction.geoWatcher === -1) { return; }
		map.SLMap.historyNaving = false;
		const event: NavEvent = NavEvents.New('navigation/gps-auto-orient');
		map.SLMap.ui.setCenter(new LngLat(info.coords.longitude, info.coords.latitude), event);
		map.SLMap.ui.setZoom(19, event);
		if (info.coords.heading) {
			map.SLMap.ui.setBearing(info.coords.heading, event);
		}
		map.SLMap.src.GPSUpdate(info.coords, event);


	}*/
}
